function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Heading } from '../../Heading';
import { Tooltip } from '../../Tooltip';
import { truncateFromMiddle } from '../helper';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListTitle(props) {
  const {
    title = '',
    titleInfo = null,
    titleUrl = '',
    onTitleClick = null,
    showTitleToolTip = false,
    noOfCharForTruncatedTitle = 30,
    isLoading = false,
    style = {}
  } = props;
  const toolTipValue = {
    text: title,
    offset: [0, 8],
    placement: 'top',
    trigger: ['hover']
  };
  const titleInfoClasses = classNames({
    [moduleStyles['sib-list__title-info']]: true
  });
  function headingHtml(title) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 2,
      size: "xs",
      fontFamily: "secondary_bold"
    }, title);
  }
  function getHeading(title) {
    return showTitleToolTip ? /*#__PURE__*/React.createElement(Tooltip, toolTipValue, headingHtml(truncateFromMiddle(title, noOfCharForTruncatedTitle))) : headingHtml(title);
  }
  return isLoading ? /*#__PURE__*/React.createElement("div", {
    className: titleInfoClasses,
    style: style
  }, props.children) : titleUrl ? /*#__PURE__*/React.createElement("a", _extends({
    href: titleUrl,
    className: titleInfoClasses
  }, typeof onTitleClick === 'function' ? {
    role: 'button',
    onClick: event => onTitleClick(event, titleUrl)
  } : {}), getHeading(title), titleInfo) : /*#__PURE__*/React.createElement("div", {
    className: titleInfoClasses
  }, getHeading(title), titleInfo);
}
ListTitle.propTypes = {
  titleUrl: PropTypes.string,
  title: PropTypes.string,
  titleInfo: PropTypes.node,
  onTitleClick: PropTypes.func,
  showTitleToolTip: PropTypes.bool,
  noOfCharForTruncatedTitle: PropTypes.number,
  isLoading: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node
};
export default ListTitle;